import {
  GET_REFUND_POLICY,
  GET_REFUND_POLICY_SUCCESS,
  GET_REFUND_POLICY_ERROR,
  POST_REFUND_POLICY,
  POST_REFUND_POLICY_SUCCESS,
  POST_REFUND_POLICY_ERROR,
  GET_LATEST_REFUND_POLICY_ERROR,
  GET_LATEST_REFUND_POLICY,
  GET_LATEST_REFUND_POLICY_SUCCESS,

} from "./actionTypes"

const INIT_STATE = {
  latest_refund_policy: null,
  latest_refund_policy_loading: null,
  latest_refund_policy_error: null,
  refund_policies: [],
  loading: false,
  error: null,
}

const RefundPolicy = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_REFUND_POLICY:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case GET_REFUND_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        refund_policies: action.payload,
      }

    case GET_REFUND_POLICY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        refund_policies: [],
      }

    case POST_REFUND_POLICY:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case POST_REFUND_POLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        refund_policies: [...state.refund_policies, action.payload.data],
      }

    case POST_REFUND_POLICY_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        refund_policies: [],
      }

    case GET_LATEST_REFUND_POLICY:
      return {
        ...state,
        latest_refund_policy_loading: true,
        latest_refund_policy_error: null,
      }

    case GET_LATEST_REFUND_POLICY_SUCCESS:
      return {
        ...state,
        latest_refund_policy: action.payload,
        latest_refund_policy_loading: false,
      }

    case GET_LATEST_REFUND_POLICY_ERROR:
      return {
        ...state,
        latest_refund_policy_loading: false,
        latest_refund_policy_error: action.payload,
      }

    default:
      return state
  }
}

export default RefundPolicy;
